const tslData = require('../translations/data.json');
//console.log('loaded data', tslData);

const defaultLanguage = 'en';
const localStorageLngKey = 'ins.io.language';

function getLocalStorage() {
	let storage = window.localStorage
	if (!storage) {
		console.error("[TSL] window.localStoare NOT ACCESIBLE");
	}
	return storage;
}

export function setLanguage(language) {
	getLocalStorage().setItem(localStorageLngKey, language);

	if (!tslData[language]) {
		console.error("[TSL] Missing translations for language", language);
	}
}

export function getLanguage () {
	const lng = getLocalStorage().getItem(localStorageLngKey);
	return lng || defaultLanguage;
}

export function tsl(constant, values = null, lang = null) {
	//console.log('translation request', constant, values, getLanguage());

	let result = constant;
	const lngData = tslData[lang || getLanguage()];

	// fall back to english on production env
	if (process.env.APP_ENV === 'prod') {
		result = tslData['en'] && tslData['en'][constant] || result;
	}

	if (lngData) {
		result = lngData[constant] || result;
	}
	

	if (values) {
		for (let key in values) {
			result = result.replace('{'+key+'}', values[key]);
		}
	}

	return result || constant;
}

export default tsl;


// WEBPACK FOOTER //
// ./app/tsl.js